import { getId } from "../utils";
import ActiveHeadline from "./activeHeadline";
export const MAX_SKILL_LEVEL = 4;
export default class Journalist {
    constructor(firstName, lastName) {
        this.id = getId();
        this.skills = {};
        this.turnsLeft = 0;
        this.firstName = firstName;
        this.lastName = lastName;
    }
    getAdjustedSkillLevel(skill) {
        return Math.min(MAX_SKILL_LEVEL, (this.skills[skill] || 0) / 5);
    }
    startProject(headline) {
        if (this.currentProject)
            this.quitCurrentProject();
        this.currentProject = headline;
        this.turnsLeft = this.getBoostedSpeed(headline);
        headline.inProgress = true;
    }
    quitCurrentProject() {
        if (!this.currentProject)
            return;
        this.currentProject.inProgress = false;
        delete this.currentProject;
        delete this.turnsLeft;
    }
    getSkillLevelForHeadline(headline) {
        if (headline.topics.length === 0)
            return 0;
        let total = 0;
        for (let topic of headline.topics) {
            total += this.getAdjustedSkillLevel(topic);
        }
        return total;
    }
    getBoostedQuality(headline) {
        const skill = this.getSkillLevelForHeadline(headline);
        const quality = Math.floor(skill);
        return Math.min(5, headline.quality + quality);
    }
    getBoostedSpeed(headline) {
        const skill = this.getSkillLevelForHeadline(headline);
        return Math.max(1, Math.ceil((headline.quality - skill) / 2));
    }
    turn(turn) {
        if (this.currentProject) {
            this.turnsLeft--;
            if (this.turnsLeft <= 0) {
                const active = new ActiveHeadline(this.currentProject, turn);
                active.quality = this.getBoostedQuality(active.content);
                for (let topic of this.currentProject.topics) {
                    this._addSkill(topic, this.currentProject.quality);
                }
                this.currentProject = null;
                return active;
            }
        }
        return null;
    }
    _addSkill(skill, quality) {
        this.skills[skill] = this.skills[skill] || 0;
        this.skills[skill] += quality;
    }
}
